<template>
  <v-dialog
  v-model="dialogEdit"
   max-width="500px"
 >
   <v-card>
     <v-card-title class="title-card">
       <span class="text-h5">{{ formTitle }}</span>
     </v-card-title>

     <v-card-text>
       <v-container>
         <v-form
            ref="form"
            v-model="valid"
          >
          <v-row>
            <v-col
              cols="12"
              sm="12"
              md="12"
            >
              <v-text-field
                v-model="obj.nome"
                required
                :rules="nameRules"
                label="Nome"
                outlined
              ></v-text-field>
            </v-col>
            <v-col
              cols="12"
              sm="12"
              md="12"
            >
              <v-text-field
                v-model="obj.cpnj"
                v-mask ="'##.###.###/####-##'"
                :rules="nameRules"
                label="CNPJ"
                required
                outlined
              ></v-text-field>
            </v-col>
            <v-col
              cols="12"
              sm="12"
              md="12"
            >
              <v-text-field
                v-model="obj.descricao"
                required
                :rules="nameRules"
                label="Descrição"
                outlined
              ></v-text-field>
            </v-col>
          </v-row>
        </v-form>
       </v-container>
     </v-card-text>

     <v-card-actions>
       <v-spacer></v-spacer>
       <v-btn
         color="primary"
         text
         @click="closeEditItem"
       >
         Cancelar
       </v-btn>
       <v-btn
         dark
         color="primary"
         @click="save"
       >
         Salvar
       </v-btn>
     </v-card-actions>
   </v-card>
 </v-dialog>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
export default {
  /* eslint-disable */
 props:{
    dialogEdit: Boolean,
    objValue: Object,
   },
   data () {
       return {
           valid:false,
           formTitle:'Editar',
           nameRules: [
               v => !!v || 'Campo requirido',
           ],
           dialog: false,
           obj: {
                descricao: '',
                nome:'',
                cpnj:'',
            },
       }
   },
   async created () {
    this.obj = this.objValue
  },
  /* eslint-disable */
  watch: {
    objValue(){
      this.obj = this.objValue
    }
  },
   methods: {
     ...mapActions('empresa', ['updateEmpresa']),
     save() {
      this.$refs.form.validate()
        /* eslint-disable no-console */
        if (this.valid) {
            this.updateEmpresa(this.obj)
            this.$emit('closeEditItem')
        }
    },
    reset () {
      this.$refs.form.reset()
    },
    closeEditItem () {
      this.$emit('closeEditItem')
    },
    computed: {
      ...mapGetters('pessoa',['getList']),
    },
       
 }
}
</script>